/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {TimePeriodBaseContract} from '../../../api/contracts/time-period-base.contract';
import {TimePeriodBaseModel} from './time-period-base.model';

export class TimePeriodBaseMapper {

    static fromTimePeriodBaseContract(input: TimePeriodBaseContract): TimePeriodBaseModel {
        let model: TimePeriodBaseModel;

        if (input != null) {
            model = {
                startDate: input.startDate,
                endDate: input.endDate
            };
        }
        return model;
    }
}
